import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { ITEM_STRUCTURE_TYPE } from "./items.constants";

export function useItemStructures() {
  return useAccountTypeStructures(ITEM_STRUCTURE_TYPE);
}
